import { GetExperienceResponseBodyType } from "@intelligems/ig-types";
import { QueryMeta, QueryOptions } from "@src/types/react-query";
import { getAuthToken } from "@src/utils";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useSwitchOrganizationByExperience } from "../organizations/switch-organization-by-experience";
import { experienceKeys } from "../queryKeys";

export const getExperience = async (
  experienceId: string
): Promise<GetExperienceResponseBodyType> => {
  const resp = await api.get<GetExperienceResponseBodyType>(
    `/v2/experiences/${experienceId}`
  );
  return resp.data;
};

export const useGetExperience = (
  experienceId: string | undefined,
  options?: QueryOptions<GetExperienceResponseBodyType, Error>
) => {
  const switchOrgByExperience = useSwitchOrganizationByExperience();
  const query = useQuery({
    ...options,
    queryKey: experienceKeys.one(experienceId!),
    queryFn: async () => getExperience(experienceId!),
    enabled:
      options?.enabled !== undefined ? options.enabled : Boolean(experienceId),
    meta: {
      onError: {
        404: () =>
          switchOrgByExperience.mutate({
            token: getAuthToken() || "",
            experienceId: experienceId,
          }),
      },
    } as QueryMeta,
  });

  return query;
};
